"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// convert named export to default for lazy react
var BaseFeatureDetail_1 = require("@jbrowse/core/BaseFeatureWidget/BaseFeatureDetail");
exports.default = BaseFeatureDetail_1.FeatureDetails;